import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              最新影视动态、深度影评、行业观察
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {article.readCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}